import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { Router } from "@angular/router";
import { AuthService } from '../_services/auth.service';
import { DataService } from '../_helpers';
import { CustomerService } from '../_services/customer.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';


@Component({
  selector: 'companiescallback',
  templateUrl: './companiescall.component.html'
})
export class CompaniesCallbackComponent implements OnInit {

  profile: any;

  isLoggedout: any;
  isSessionNew: any;
  isNewArrival: any;
  isAuthLoginReached: any;

  constructor(private http: HttpClient
    , private router: Router
    , private auth: AuthService
    , private customerService: CustomerService
    , private dataService: DataService
    , private spinnerService: Ng4LoadingSpinnerService) {
      this.spinnerService.show();
  }//end cosnt

  ngOnInit() {
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      this.router.navigate(['/home']);
    }
    else {
      this.viewcompanieslist();
    }


  }

  async viewcompanieslist() {
    localStorage.removeItem('isCorporateCompany');
    localStorage.removeItem('accessmenu');
    this.GetSubCompanyName();
    await this.auth.GetConfigCorpMenuDetails();
  }

  GetSubCompanyName() {
    this.customerService.getCustomerCompanyDetailsList(localStorage.getItem('companyId')).subscribe(d => {
      localStorage.setItem('isCorporate', 'Yes');
      localStorage.setItem('customername', d.body.name);
      localStorage.setItem('subcompanyId', d.body.public_id);
      this.dataService.changeuserprofilename(localStorage.getItem('customername'));
    },
      error => {
        console.log('Failed while trying to the Company Name.' + error)
      });

  }
}